import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const recruiterSettings = {
    mobile: {
        mainWrapper: {
            display: "flex",
            flexDirection: "column" as "column",
            overflow: "hidden"
        },
        leftWrapper: {
            height: "42.51vw"    
        },
        rightWrapper:{
            paddingLeft: "4.83vw",
            paddingTop: "6.76vw"
        },        
        searchWrapper: {
            display: "none"
        },
        searchBar: {
            display: "none"
        },
        profileWrapper: {
            display: "flex"
        },
        topic: {
            fontSize: "6.03vw",
            fontWeight: "bold" as "bold"
        },
        tabcontent: {
            height: " 12.80vw",
            marginTop: "3.86vw",
            marginBottom: "9.66vw"
        },
        tab: {
            width: "fit-content",
            padding: "1.93vw 3.38vw 2.41vw 3.62vw",
            borderRadius: "6.03vw",
            fontSize: "3.62vw",
            color: Color.SharpAsh,
            backgroundColor: Color.LightAsh,
            marginTop: "1.93vw",
            marginRight: "2.41vw",
            active: {
                color: Color.White,
                backgroundColor: Color.Blue
            }
        },
        account: {
            profile: {
                display: "flex",
                flexDirection: "column" as "column"
            },
            profileName: {
                fontSize: "3.86vw",
                fontFamily: Font.Poppins,
                color: Color.DeepAsh,
                marginBottom: "2.89vw"
            },
            profilePhoto: {
                width: "38.88vw",
                height: "38.88vw",
                borderRadius: "50%",
                objectFit: "cover"
            },
            logo: {
                width: "9.90vw",
                height: "9.90vw",
                borderRadius: "50%",
                backgroundColor: Color.White,
                position: "relative",
                zIndex: "2",
                left: "14.47vw",
                top: "-11.35vw"
            },
            cameraIcon: {
                width: "4.70vw",
                height: "3.53vw",
                margin:  "3.18vw 0.60vw 3.18vw 0.80vw",
                fill: Color.MiddleBlack
            },
            fileInput: {
                display: "none"
            },
            formGruop: {
                display: "flex",
                flexDirection: "column" as "column",
                width: "90.33vw"
            },
            form: {
                width: "90.33vw",
                marginBottom: "-6.24vw"
            },
            label: {
                fontSize: "3.86vw",
                color: Color.DeepAsh,
                fontFamily: Font.Poppins,
                marginLeft: "3.62vw"
            },
            inputWrapper: {
                height: "18.84vw",
                marginBottom: "4.83vw"
            },
            textInput: {
                height: "12.07vw",
                fontSize: "3.86vw",
                marginTop: "0.80vw",
                borderRadius: "1.20vw",
                backgroundColor: Color.LightAsh
            },
            textGroup: {
                fontSize: "3.86vw",
                marginTop: "0.80vw"
            },
            line: {
                marginTop: "7.24vw",
                marginBottom: "7.24vw",
                width: "90.33vw",
                height: "0.30vw",
                border: "none",
                backgroundColor: Color.MiddleAsh
            },
            subTopic: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                fontSize: "3.86vw",
                fontWeight: "bold" as "bold",
                marginLeft: "4.83vw"
            },
            droupDownIcon: {
                width: "4.10vw",
                height: "4.58vw",
                marginLeft: "42.44vw",
                active: {
                    transform: "rotate(180deg)"
                }
            },
            updatePassword: {
                width: "90.33vw",
                marginTop: "7.24vw"
            },
            updateButton: {
                width: "58.69vw",
                height: "12.07vw",
                fontSize: "4.34vw",
                fontWeight: "bold" as "bold",
                backgroundColor: Color.Blue,
                color: Color.White,
                borderRadius: "2.41vw",
                boxShadow: "1.20vw 1.20vw 12.07vw #00000027",
                marginLeft: "31.64vw",
                marginTop: "2.41vw"   
            },
            saveButton: {
                width: "90.33vw",
                height: "12.07vw",
                fontSize: "4.34vw",
                fontWeight: "bold" as "bold",
                backgroundColor: Color.Green,
                color: Color.White,
                borderRadius: "2.41vw",
                boxShadow: "1.20vw 1.20vw 12.07vw #00000027",
                marginTop: "1.56vw"
            },
            uploadImagePopup: {
                container: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "50%"
                }
            },
            uploadedImage: {
                display: "block",
                width: "80%",
                height: "80%",
                objectFit: "cover",
                borderRadius: "2.42vw",
                margin: "auto",
                border: "2px solid " + Color.MiddleAsh
            },
            uploadImageButton: {
                border: "none",
                color: Color.White,
                width: "100%",
                height: "5.58vh",
                borderRadius: "2.41vw",
                fontSize: "4.34vw",
                fontWeight: "bold" as "bold",
                textTransform: "uppercase",
                cursor: "pointer",
                backgroundColor: Color.Blue
            }
        },
        organization: {
            profilePhoto: {
                display: "flex",
                flexDirection: "column" as "column"
            },
            logoName: {
                fontSize: "3.86vw",
                fontFamily: Font.Poppins,
                color: Color.DeepAsh,
                marginLeft: "2.41vw"
            },
            organizationLogo: {
                marginTop: "2.89vw",
                width: "38.88vw",
                height: "38.88vw",
                borderRadius: "1.20vw"
            },
            logo: {
                width: "9.90vw",
                height: "9.90vw",
                borderRadius: "50%",
                backgroundColor: Color.White,
                position: "relative",
                zIndex: "1",
                left: "27.05vw",
                top: "-11.83vw"
            },
            fileInput: {
                display: "none"
            },
            cameraIcon: {
                width: "4.70vw",
                height: "3.53vw",
                marginLeft: "-0.10vw",
                marginTop: "0.98vw",
                fill: Color.MiddleBlack
            },
            tabSwitch: {
                switch: {
                    backgroundColor: Color.LightGray,
                    borderRadius: "69.44vw",
                    cursor: "pointer",
                    display: "flex",
                    height: "5.79vw",
                    width: "9.66vw",
                    padding: "0.56vw",
                    margin: "auto",
                    marginRight: "unset",
                    WebkitTapHighlightColor: "transparent",
                    checked: {
                        backgroundColor: Color.SharpGreen
                    }
                },
                switchCircle: {
                    height: "5vw",
                    width: "5vw",
                    borderRadius: "50%",
                    backgroundColor: Color.White,
                    checked: {
                        marginLeft: "auto",
                        backgroundColor: Color.Green
                    }
                }
            },
            label: {
                fontSize: "3.86vw",
                color: Color.DeepAsh,
                fontFamily: Font.Poppins,
                marginLeft: "3.62vw",
                fontWeight: "Regular" as "Regular"
            },
            inputWrapper: {
                height: "18.84vw", 
                marginBottom: "4.83vw"
            },
            textInput: {
                marginTop: "1.20vw",
                width: "90.33vw",
                height: "12.07vw",
                borderRadius: "1.20vw"
            },
            textGroup: {
                marginTop: "1.20vw",
                width: "90.33vw",
                height: "12.07vw",
                borderRadius: "1.20vw",
                backgroundColor: Color.LightAsh
            },
            textArea: {
                marginBottom: "4.83vw"
            },
            textAreaInput: {  
                marginTop: "1.20vw",
                textArea: {
                    width: "90.33vw",
                    height: "59.42vw"
                }
            },
            line: {
                marginTop: "7.24vw",
                marginBottom: "7.24vw",
                width: "90.33vw",
                height: "0.15vw",
                border: "none",
                marginLeft: "0vw",
                backgroundColor: Color.MiddleAsh
            },
            adressInput: {
                width: "90.33vw",
                height: "30.67vw"
            },
            iconWrapper: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "9.66vw",
                height: "9.66vw",
                cursor: "pointer",
                backgroundColor: Color.Cultured,
                borderRadius: "50%",
                margin: "2.17vw 0  0.46vw 0.98vw"
            },
            plusIcon: {
                fill: Color.SharpAsh,
                width: "4.07vw",
                height: "4.07vw"
            },
            mainTab: {
                display: "flex",
                flexDirection: "row" as "row",
                backgroundColor: Color.Cultured,
                borderRadius: "2.41vw",
                width: "90.33vw",
                height: "19.32vw",
                border: "3px solid" + Color.MiddleAsh,
                padding: "4.10vw 4.83vw 3.86vw 4.83vw",
                boxSizing: "border-box" as "border-box"             
            },
            tab: {
                display: "flex",
                flexDirection: "row" as "row",
                width: "90.33vw",
                height: "14.49vw",
                borderRadius: "2.41vw",
                padding: "4.34vw 4.83vw 4.34vw 4.83vw",
                boxSizing: "border-box" as "border-box",
                border: "3px solid" + Color.MiddleAsh,
                marginTop: "2.89vw"     
            },
            mainTabText: {
                fontFamily: Font.Default,
                fontSize: "3.86vw",
                color: Color.Black,
                fontWeight: "bold" as "bold" 
            },
            tabSubText: {
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                color: Color.DeepAsh,
                marginTop: "1.44vw",
                fontWeight: "Regular" as "Regular" 
            },
            tabText: {
                maxWidth: "50.06vw",
                fontFamily: Font.Default,
                fontSize: "3.86vw",
                color: Color.Black,
                fontWeight: "bold" as "bold"    
            },
            socialInputLabel: {
                fontSize: "3.86vw",
                color: Color.DeepAsh,
                fontFamily: Font.Poppins,
                marginLeft: "17.63vw",
                fontWeight: "Regular" as "Regular"
            },
            inputWithIcon: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "3.82vw"
            },
            inputWithPlusIcon: {
                display: "flex",
                flexDirection: "column" as "column",
                marginBottom: "4.83vw"
            },
            socialIconWrapper: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "3.64vw",
                height: "3.64vw",
                marginTop: "2.43vw",
                marginRight: "6.40vw"
            },
            socialIcon: {
                width: "3.77vw",
                height: "3.77vw",
                fill: Color.MiddleBlack,
                twitter: {
                    stroke: Color.MiddleBlack
                }
            },
            uploadImagePopup: {
                container: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "50%"
                }
            },
            socialInput: {
                marginTop: "1.20vh",
                width: "76.32vw",
                marginRight: "4.83vw"
            },
            spanWrapper: {
                display: "flex",
                flexDirection: "column" as "column",
                minHeight: "5.46vw",
                marginBottom: "1.30vw"
            },
            saveButton: {
                width: "90.33vw",
                height: "12.07vw",
                fontSize: "4.34vw",
                fontWeight: "bold" as "bold",
                backgroundColor: Color.Green,
                color: Color.White,
                borderRadius: "2.41vw",
                boxShadow: "1.20vw 1.20vw 12.07vw #00000027",
                marginTop: "10.86vw"   
            },
            uploadedImage: {
                display: "block",
                width: "80%",
                height: "80%",
                objectFit: "cover",
                borderRadius: "2.42vw",
                margin: "auto",
                border: "2px solid " + Color.MiddleAsh
            },
            uploadImageButton: {
                border: "none",
                color: Color.White,
                width: "100%",
                height: "5.58vh",
                borderRadius: "2.41vw",
                fontSize: "4.34vw",
                fontWeight: "bold" as "bold",
                textTransform: "uppercase",
                cursor: "pointer",
                backgroundColor: Color.Blue
            }
        },
        integration: {
            mainWrapper: {
                display: "flex",
                flexDirection: "column" as "column"
            },
            leftWrapper: {
                width: "90.33vw"
            },
            tabContent: {
                display: "flex",
                flexDirection: "row" as "row"
            },
            tabButton: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "45.16vw",
                height: "9.66vw",
                fontSize: "3.86vw",
                color: Color.DeepAsh,
                borderRadius: "1.20vw",
                boxSizing: "border-box" as "border-box",
                fontWeight: "Regular" as "Regular", 
                backgroundColor: Color.LightAsh,
                active: {
                    backgroundColor: Color.DeepBlack,
                    color: Color.LightAsh
                } 
            },
            tabIcon: {
                display: "none",
                active: {
                    display: "none"    
                }
            },
            careerPage: {
                mainWrapper: {
                    display: "flex",
                    flexDirection: "column" as "column"
                },
                leftWrapper: {
                    display: "flex",
                    flexDirection: "column" as "column",
                    order: 2
                },
                rightWrapper: {
                    display: "flex",
                    flexDirection: "column" as "column",
                    alignSelf: "flex-start",
                    order: 1,
                    width: "90.33vw",
                    height: "auto",
                    border: "0.48vw solid #DEDEDE",
                    borderRadius: "2.41vw",
                    marginTop: "9.66vw",
                    marginBottom: "12.80vw",
                    paddingBottom: "7.24vw"
                },
                headerText: {
                    width: "76.81vw",
                    height: "10.38vw",
                    fontSize: "3.86vw",
                    fontWeight: "bold" as "bold",
                    marginBottom: "4.83vw",
                    marginLeft: "2.41vw"
                },
                subText: {
                    width: "82.12vw",
                    height: "auto",
                    fontFamily: Font.Poppins,
                    fontSize: "3.62vw",
                    fontWeight: "Regular" as "Regular",
                    color: Color.DeepAsh,
                    marginLeft: "2.41vw"
                },
                domainHeader: {
                    fontSize: "3.86vw",
                    color: Color.Black,
                    fontWeight: "bold" as "bold",
                    marginLeft: "4.83vw",
                    marginTop: "4.83vw",
                    marginBottom: "4.83vw"
                },
                inputLabel: {
                    fontFamily: Font.Poppins,
                    fontSize: "3.86vw",
                    fontWeight: "Regular" as "Regular",
                    color: Color.DeepAsh,
                    marginLeft: "6.03vw"
                },
                duplicateIcon: {
                    width: "3.86vw",
                    height: "4.34vw",
                    marginLeft: "7.24vw",
                    cursor: "pointer"
                },
                jobListSnippet: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "52.89vw",
                    height: "14.25vw",
                    fontSize: "3.62vw",
                    color: Color.SharpAsh,
                    border: "0.24vw solid #D5D5D6",
                    marginTop: "4.03vw",
                    marginBottom: "4.77vw",
                    borderRadius: "2.41vw",
                    position: 'relative'
                },
                javaScriptSnippet: {
                    width: " 90.33vw",
                    height: "50vw",
                    border: "0.24vw solid #D5D5D6",
                    marginTop: "4.58vw",
                    marginBottom: "8.45vw",
                    borderRadius: "2.41vw",
                    fontSize: "3.62vw",
                    color: Color.SharpAsh,
                    fontWeight: "medium" as "medium",
                    padding: "4.83vw 0.05vw 4.83vw 4.83vw",
                    boxSizing: "border-box" as "border-box",
                    lineHeight: "5.55vw"
                },
                cssStyleSnippet: {
                    width: "90.82vw",
                    height: "19.80vw",
                    border: "0.24vw solid #D5D5D6",
                    marginTop: "4.83vw",
                    marginBottom: "8.45vw",
                    borderRadius: "2.41vw",
                    fontSize: "3.62vw",
                    color: Color.SharpAsh,
                    padding: "4.83vw 3.68vw 4.83vw 4.83vw",
                    boxSizing: "border-box" as "border-box",
                    position: "relative",
                    icon: {
                        position: "relative",
                        width: "3.62vw",
                        height: "4.10vw",
                        left: "10.01vw",
                        top: "2.56vw",
                        cursor: "pointer"
                    }
                },
                dulicateMessage: {
                    boxShadow: "3px 3px 10px #00000029",
                    display: "none",
                    position: 'absolute',
                    fontSize: "3.62vw",
                    fontFamily: Font.Poppins, 
                    padding: "2.41vw",                  
                    border: "1px solid " + Color.Gray,
                    borderRadius: "2.41vw",
                    backgroundColor: Color.White,
                    jobListSnippet: {
                        display: "block",
                        top: "-20%",
                        left: "49.51vw",             
                        borderTop: "1px solid #D1D1D1",
                        borderLeft: "1px solid #D1D1D1",
                        boxShadow: "7px 7px 10px #00000029"   
                    },
                    javaScriptSnippet: {
                        display: "block",
                        top: "24%",
                        left: "72.75vw",             
                        borderTop: "1px solid #D1D1D1",
                        borderLeft: "1px solid #D1D1D1",
                        boxShadow: "7px 7px 10px #00000029"   
                    },
                    cssStyleSnippet: {
                        display: "block",
                        top: "0%",
                        left: "78.75vw",        
                        borderTop: "1px solid #D1D1D1",
                        borderLeft: "1px solid #D1D1D1",
                        boxShadow: "7px 7px 10px #00000029"    
                    }                      
                },
                textInput: {
                    width: '85.50vw',
                    height: '12.07vw',
                    marginLeft: '2.41vw'
                },
                submitButton: {
                    width: "50.72vw",
                    height: "8.45vw",
                    fontSize: "3.38vw",
                    fontWeight: "bold" as "bold",
                    color: Color.White,
                    padding: "2.41vw 14.00vw 2.41vw 14.00vw",
                    backgroundColor: Color.Green,
                    borderRadius: "1.69vw",
                    boxShadow: "1.20vw 1.20vw 12.07vw #00000027",
                    marginLeft: "37.19vw",
                    marginTop: "2.89vw"
                },
                line: {
                    width: "85.50vw",
                    marginTop: "6.03vw",
                    marginBottom: "6.03vw",
                    marginLeft: "2.41vw"
                },
                domainContent: {
                    display: "flex",
                    flexWrap: "wrap" as "wrap",
                    alignContent: "flex-start",
                    width: "85.50vw",
                    height: "auto",
                    marginLeft: "2.41vw",
                    marginRight: "2.41vw",
                    boxSizing: "border-box" as "border-box"
                },
                domains: {
                    display: "flex",
                    flexDirection: "row" as "row",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "max-content",
                    maxWidth: "100%",
                    height: "auto",
                    fontSize: "3.38vw",
                    fontWeight: "bold" as "bold",
                    backgroundColor: Color.BrightGray,
                    borderRadius: "1.69vw",
                    padding: "2.83vw",
                    marginRight: "2.41vw",
                    marginTop: "2.41vw",
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                    boxSizing: "border-box" as "border-box"
                },
                closeIcon: {
                    width: "4.34vw",
                    height: "4.34vw",
                    minWidth: "4.34vw",
                    minHeight: "4.34vw",
                    marginLeft: "2.41vw",
                    marginRight: "2.41vw",
                    cursor: "pointer"
                },
                innerJavaScriptSnippet: {
                    marginTop: "6.28vw",
                    position: "relative",
                    icon: {
                        position: "relative",
                        width: "3.62vw",
                        height: "3.86vw",
                        left: "63.00vw",
                        top: "2.5vw",
                        cursor: "pointer"
                    }
                },
                redText: {
                    color: Color.FaluRed,
                    marginLeft: "0.40vw"
                },
                greenText: {
                    color: Color.Green
                },
                pinkText: {
                    color: Color.Frostbite
                },
                yellowText: {
                    color: Color.HarvestGold,
                    marginRight: "1.20vw"
                },
                purpleText: {
                    color: Color.MediumPurple  
                },
                blueText: {
                    color: Color.Blue
                },
                yellowTextWithMargin: {
                    color: Color.HarvestGold,
                    marginLeft: "5.86vw",
                    marginRight: "1.20vw"
                },
                blueTextWithMargin: {
                    color: Color.Blue,
                    marginLeft: "5.86vw"
                },
                additionalContent: {
                    width: "90.33vw",
                    height: "78.50vw",
                    border: "0.48vw solid #01A9E0",
                    marginBottom: "12.07vw",
                    borderRadius: "2.41vw",
                    backgroundColor: Color.LightBlue
                },
                additionalHeader: {
                    fontSize: "3.86vw",
                    fontWeight: "bold" as "bold",
                    color: Color.Black,
                    marginTop: "5.07vw",
                    marginLeft: "6.2vw",
                    marginBottom: "4.83vw"
                },
                option: {
                    display: "flex",
                    flexDirection: "row" as "row",
                    alignItems: "center",
                    marginLeft: "4.04vw",
                    marginBottom: "2.41vw"
                },
                optionButton: {
                    width: "auto",
                    height: "7.72vw",
                    fontSize: "3.62vw",
                    color: Color.White,
                    padding: "1.69vw 3.83vw 1.93vw 3.83vw",
                    backgroundColor: Color.Blue,
                    borderRadius: "2.41vw"
                },
                defaultText: {
                    display: "flex",
                    fontSize: " 3.62vw",
                    color: Color.SharpAsh,
                    marginLeft: "2.89vw"
                },
                answerText: {
                    display: "flex",
                    fontSize: " 3.62vw",
                    color: Color.Blue
                },
                loader : {
                    width: "85.50vw",
                    height: "18.35vw",
                    marginLeft: "2.03vw",
                    marginTop: "5vw"
                }   
            },
            blueLotus: {
                mainWrapper: {
                    width: "90.33vw",
                    height: "87.19vw"
                },
                headerText: {
                    fontSize: "3.86vw",
                    color: Color.Black,
                    fontWeight: "bold" as "bold",
                    marginLeft: "2.41vw",
                    marginBottom: "3.62vw",
                    marginTop: " 9.66vw"
                },
                inputLabel: {
                    fontFamily: Font.Poppins,
                    fontSize: "3.86vw",
                    fontWeight: "Regular" as "Regular",
                    color: Color.DeepAsh,
                    marginLeft: "3.62vw"
                },
                textInput: {
                    width: "90.33vw",
                    height: "12.07vw"
                },
                submitButton: {
                    width: "50.72vw",
                    height: "8.45vw",
                    fontSize: "3.38vw",
                    fontWeight: "bold" as "bold",
                    color: Color.White,
                    padding: "2.41vw 14.21vw 2.41vw 14.21vw",
                    backgroundColor: Color.Green,
                    borderRadius: "1.69vw",
                    boxShadow: "1.20vw 1.20vw 12.07vw #00000027",
                    marginLeft: "39.61vw",
                    marginTop: "2.89vw"
                },
                line: {
                    marginTop: "6.03vw",
                    marginBottom: "6.03vw",
                    width: "90.33vw",
                    height: "0.15vw",
                    border: "none",
                    backgroundColor: Color.MiddleAsh 
                },
                domainContent: {
                    display: "flex",
                    flexWrap: "wrap",
                    width: "90.33vw",
                    height: "auto",
                    marginRight: "4.83vw"
                },
                domains: {
                    display: "flex",
                    flexDirection: "row" as "row",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "auto",
                    height: "8.93vw",
                    fontSize: "3.38vw",
                    fontWeight: "bold" as "bold",
                    backgroundColor: Color.BrightGray,
                    borderRadius: "1.696vw",
                    paddingLeft: "4.83vw",
                    marginRight: "2.41vw",
                    marginTop: "2.41vw",
                    boxSizing: "border-box" as "border-box"
                },
                closeIcon: {
                    width: "4.34vw",
                    height: "4.34vw",
                    marginLeft: "2.41vw",
                    marginRight: "4.83vw",
                    cursor: "pointer"
                },
                loader: {
                    width: "90.33vw",
                    height: "12.07vw",
                    marginLeft: "1.00vw",
                    marginTop: "5vw"
                }
            }
        }
    },
    desktop: {
        mainWrapper: {
            flexDirection: "row" as "row",
            paddingLeft: "1.56vw",
            paddingTop: "1.56vw",
            boxSizing: "border-box" as "border-box"   
        },
        leftWrapper: {
            width: "19.27vw",
            boxSizing: "border-box" as "border-box"
        },
        rightWrapper:{
            display: "flex",
            paddingLeft: "0",
            paddingTop: "0",
            width: "100%",
            flexDirection: "column" as "column",
            marginBottom: "5vw"
        },
        profileWrapper: {
            marginLeft: "auto"
        },
        headerWrapper:{
            height: "5.72vw",
            paddingLeft: "2.5vw"
        },
        topic: {
            height: "2.91vw",
            fontSize: "2.60vw",
            marginLeft: "2.91vw"
        },
        tabcontent: {
            height: " 2.60vw",
            marginTop: "1.19vw",
            marginLeft: "1.97vw"
        },
        tab: {
            padding: "0.36vw 1.04vw 0.41vw 1.04vw",
            borderRadius: "1.30vw",
            fontSize: "0.93vw",
            fontWeight: "Medium" as "Medium",
            marginTop: "0.36vw",
            marginLeft: "0.92vw",
            marginRight: "-0.26vw"
        },
        content: {
            marginTop: "-7.0vw"
        },
        account: {
            mainWrapper: {
                display: "flex",
                flexDirection: "row" as "row"
            },
            profile: {
                display: "flex",
                flexDirection: "column" as "column",
                justifyContent: "flex-start",
                alignItems: "center",
                marginLeft: "8.59vw"
            },
            profileName: {
                fontSize: "0.9375vw",
                marginBottom: "1.042vw",
                height: "1.30vw"
            },
            profilePhoto: {
                width: "14.06vw",
                height: "14.06vw",
                borderRadius: "50%"
            },
            logo: {
                width: "2.34vw",
                height: "2.34vw",
                borderRadius: "50%",
                zIndex: "3",
                left: "0vw",
                top: "-2.96vw"
            },
            cameraIcon: {
                width: "1.14vw",
                height: "0.86vw",
                margin: "0.72vw 0.05vw 0.75vw 0.05vw"
            },
            fileInput: {
                display: "none"
            },
            formGruop: {
                display: "flex",
                flexDirection: "column" as "column",
                marginLeft: " 6.56vw",
                width: "42.29vw"
            },
            form: {
                width: "42.29vw",
                marginBottom: "-1.36vw"
            },
            label: {
                fontSize: "0.9375vw",
                marginLeft: "0.52vw"
            },
            inputWrapper: {
                height: "5.46vw",
                marginBottom: "1.30vw"
            },
            inputGroup: {
                display: "flex",
                height: "5.46vw",
                flexDirection: "row" as "row",
                justifyContent: "space-between"
            },
            textInput: {
                width: "42.29vw",
                height: " 3.64vw",
                marginTop: "0.32vw",
                borderRadius: "0.52vw",
                inputError: {
                    icon: {
                        position: "relative",
                        bottom: "0.9vw"
                    }
                }
            },
            textGroup: {
                width: "20.72vw",
                height: " 3.64vw",
                borderRadius: "0.52vw",
                marginTop: "0.32vw",
                backgroundColor: Color.LightAsh,
                inputError: {
                    icon: {
                        position: "relative",
                        bottom: "0.9vw"
                    }
                }
            },
            line: {
                marginTop: "1.56vw",
                marginBottom: "1.56vw",
                width: "42.29vw",
                height: "0.03vw",
                border: "none",
                backgroundColor: Color.MiddleAsh
            },
            subTopic: {
                fontSize: "1.04vw",
                fontWeight: "bold" as "bold",
                marginLeft: "0.52vw",
                color: Color.DeepBlack,
                cursor: "pointer"
            },
            droupDownIcon: {
                width: " 0.88vw",
                height: "0.98vw",
                marginLeft: "29.14vw",
                marginRight: "0.52vw",
            },
            updatePassword: {
                marginTop: "1.56vw",
                width: "42.29vw"
            },
            updateButton: {
                width: "20.72vw",
                height: "2.60vw",
                fontSize: "1.04vw",
                fontWeight: "bold" as "bold",
                borderRadius: "0.52vw",
                boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                marginLeft: "21.56vw"   
            },
            saveButton: {
                width: "20.78vw",
                height: "3.64vw",
                fontSize: "1.04vw",
                borderRadius: "0.52vw",
                boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                marginTop: "1.56vw"   
            },
            uploadImagePopup: {
                container: {
                    width: "20vw",
                    height: "20vw",
                    bottom: "unset"
                }
            },
            uploadedImage: {
                height: "80%",
                width: "70%",
                borderRadius: "0.52vw"
            },
            uploadImageButton: {
                height: "5vh",
                borderRadius: "0.48vw",
                fontSize: "0.83vw"
            }
        },
        organization : {
            mainWrapper: {
                display: "flex",
                flexDirection: "row" as "row"
            },
            leftWrapper: {
                marginLeft: "8.59vw"
            },
            organizationLogo: {
                marginTop: "0vw",
                display: "flex",
                flexDirection: "column" as "column",
                width: "14.06vw",
                height: "14.06vw",
                borderRadius: "0.52vw" 
            },
            logoName: {
                display: "flex",
                justifyContent: "center",
                fontSize: "0.93vw",
                marginBottom: "1.04vw",
                marginLeft: "0vw"
            },
            logo: {
                width: "2.34vw",
                height: "2.34vw",
                borderRadius: "50%",
                position: "relative",
                left: "11.14vw",
                top: "-2.96vw"
            },
            cameraIcon: {
                width: "1.14vw",
                height: "0.86vw",
                marginLeft: "0.03vw",
                marginTop: "0.18vw" 
            },
            tabs: {
                marginTop: "0.67vw"     
            },
            mainTab: {
                borderRadius: "0.52vw",
                width: "14.06vw",
                height: "5.31vw",
                padding: "1.19vw 1.04vw 1.19vw 1.35vw"             
            },
            tab: {
                width: "14.06vw",
                height: "auto",
                borderRadius: "0.52vw",
                padding: "0.67vw 1.04vw 0.67vw 1.35vw",
                boxSizing: "border-box" as "border-box",
                marginTop: "0.78vw"     
            },
            mainTabText: {
                fontFamily: Font.Poppins,
                fontSize: "0.93vw",
                color: Color.DeepAsh
            },
            tabText: {
                maxWidth: "6.40vw",
                fontSize: "0.93vw",
                color: Color.DeepAsh,
                lineHeight: "1.1vw"
            },
            tabSubText: {
                fontSize: "0.93vw",
                marginTop: " 0.31vw"
            },
            tabSwitch: {
                switch: {
                    borderRadius: "0.93vw",
                    height: "1.87vw",
                    width: "3.22vw",
                    padding: "0.26vw",
                    boxSizing: "border-box" as "border-box"
                },
                switchCircle: {
                    height: "1.35vw",
                    width: "1.35vw"
                }
            },
            form: {
                width: "42.29vw",
                marginLeft: "6.56vw"
            },
            inputGroup: {
                display: "flex",
                height: "5.46vw",
                flexDirection: "row" as "row",
                justifyContent: "space-between"
            },
            textGroup: {
                marginTop: "0.52vw",
                width: "20.72vw",
                height: " 3.64vw",
                borderRadius: "0.52vw"
            },
            label: {
                fontSize: "0.93vw",
                marginLeft: "0.52vw"
            },
            textArea: {
                marginTop: "1.56vw",
                marginBottom: "1.30vw"
            },
            textAreaInput: {  
                marginTop: "0.52vw",
                textArea: {
                    width: "42.29vw",
                    height: "11.56vw"
                }
            },
            inputWrapper: {
                height: "5.46vw",
                marginBottom: "1.30vw"
            },
            tinInputWrapper: {
                height: "5.46vw",
                marginBottom: "1.30vw",
                marginTop: "1vw"
            },
            textInput: {
                marginTop: "0.52vw",
                width: "42.29vw",
                height: "3.64vw",
                borderRadius: "0.52vw"
            },
            spanWrapper: {
                minHeight: "5.46vw",
                marginBottom: "1.30vw"
            },
            line: {
                marginTop: "1.56vw",
                marginBottom: "1.56vw",
                width: "42.29vw",
                height: "0.15vw",
                border: "none",
                marginLeft: "0vw"
            },
            inputWithIcon: {
                marginLeft: "0vw"
            },
            inputWithPlusIcon: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "1.30vw"
            },
            adressInput: {
                width: "38.43vw",
                height: "3.64vw"
            },
            socialInput: {
                marginTop: "0.52vh",
                width: "36.40vw",
                marginRight: "0"
            },
            iconWrapper: {
                width: "2.86vw",
                height: "2.86vw",
                borderRadius: "50%",
                margin: "1.2vw 0  0.86vw 0.8vw"
            },
            socialIconWrapper: {
                width: "3.64vw",
                height: "3.64vw",
                marginTop: "0.05vw",
                marginRight: "1.87vw"
            },
            plusIcon: {
                width: "1.09vw",
                height: "1.09vw"
            },
            socialIcon: {
                width: "1.25vw",
                height: "1.25vw",
                twitter: {
                    stroke: Color.MiddleBlack,
                    width: "1vw",
                    height: "1vw"
                },
                linkedIn: {
                    width: "1vw",
                    height: "1vw"
                }
            },
            socialInputLabel: {
                fontSize: "0.93vw",
                marginLeft: "6.04vw"
            },
            attachment: {
                selectedFileName: {
                    fontFamily: Font.Poppins,
                    fontSize: "0.93vw",
                    color: Color.SharpAsh,
                    margin: "1.19vw 0 1.14vw 1.56vw"
                },
                fileIcon: {
                    marginRight: "1.51vw"
                }
            },
            saveButton: {
                width: "20.78vw",
                height: "3.64vw",
                fontSize: "1.04vw",
                borderRadius: "0.52vw",
                boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                marginTop: "3.64vw"   
            },
            uploadImagePopup: {
                container: {
                    width: "20vw",
                    height: "20vw",
                    bottom: "unset"
                }
            },
            uploadedImage: {
                height: "80%",
                width: "70%",
                borderRadius: "0.52vw"
            },
            uploadImageButton: {
                height: "5vh",
                borderRadius: "0.48vw",
                fontSize: "0.83vw"
            }
        },
        integration: {
            mainWrapper: {
                display: "flex",
                flexDirection: "row" as "row"
            },
            leftWrapper: {
                marginLeft: "2.5vw",
                width: "13.90vw"
            },
            tabContent: {
                display: "flex",
                flexDirection: "column" as "column"
            },
            tabButton: {
                justifyContent: "space-between",
                width: "13.90vw",
                height: "2.34vw",
                border: "0.10vw solid #D9D9D9",
                fontSize: "1.04vw",
                color: Color.SharpAsh,
                borderRadius: "0.52vw",
                marginBottom: "0.52vw",
                paddingLeft: "1.04vw",
                paddingRight: "1.04vw",
                fontWeight: "500",
                backgroundColor: Color.White, 
                active: {
                    backgroundColor: Color.LightAsh,
                    color: Color.Black,
                    border: "0.10vw solid #0B132B"
                } 
            },
            tabIcon: {
                display: "none",
                active: {
                    display: "block",
                    transform: "rotate(270deg)",
                    width: "0.80vw",
                    height: "0.73vw"    
                }
            },
            rightWrapper: {
                marginLeft: "1.04vw"
            },
            careerPage: {
                mainWrapper: {
                    display: "flex",
                    flexDirection: "row" as "row",
                },
                leftWrapper: {
                    display: "flex",
                    flexDirection: 'column',
                    order: 1
                },
                headerText: {
                    width: "30.52vw",
                    height: "1.19vw",
                    fontSize: "1.04vw",
                    marginLeft: "1.40vw",
                    marginBottom: "2.08vw"
                },
                subText: {
                    width: "31.25vw",
                    height: "auto",
                    fontSize: "0.93vw",
                    marginLeft: "1.56vw"
                },
                duplicateIcon: {
                    width: "0.93vw",
                    height: "1.14vw",
                    marginLeft: "1.56vw"
                },
                jobListSnippet: {
                    width: "12.96vw",
                    height: "3.22vw",
                    marginLeft: "1.04vw",
                    fontSize: "0.93vw",
                    border: "0.05vw solid #D5D5D6",
                    marginTop: "1.04vw",
                    marginBottom: "1.56vw",
                    borderRadius: "0.52vw"
                },
                javaScriptSnippet: {
                    width: "33.64vw",
                    height: "9.63vw",
                    marginLeft: "1.04vw",
                    border: "0.05vw solid #D5D5D6",
                    marginTop: "1.04vw",
                    marginBottom: "1.56vw",
                    borderRadius: "0.52vw",
                    fontSize: "0.93vw",
                    padding: "1.04vw 1.04vw 1.04vw 1.04vw",
                    boxSizing: "border-box" as "border-box",
                    lineHeight: "1.20vw"
                },
                innerJavaScriptSnippet: {
                    marginTop: "1.36vw",
                    icon: {
                        position: "relative",
                        width: "0.93vw",
                        height: "1.14vw",
                        left: "26.25vw",
                        top: "0vw"
                    }
                },
                yellowText: {
                    marginRight: "0.26vw"
                },
                cssStyleSnippet: {
                    width: "33.75vw",
                    height: "4.42vw",
                    marginLeft: "1.04vw",
                    border: "0.05vw solid #D5D5D6",
                    marginTop: "1.04vw",
                    marginBottom: "1.56vw",
                    borderRadius: "0.52vw",
                    fontSize: "0.93vw",
                    padding: "1.04vw 1.04vw 1.04vw 1.04vw",
                    boxSizing: "border-box" as "border-box",
                    icon: {
                        position: "relative",
                        width: "0.93vw",
                        height: "1.14vw",
                        left: "17.0vw",
                        top: "0.2vw"
                    }
                },
                yellowTextWithMargin: {
                    color: Color.HarvestGold,
                    marginLeft: "2.2vw",
                    marginRight: "0.26vw"
                },
                blueTextWithMargin: {
                    color: Color.Blue,
                    marginLeft: "-0.22vw"
                },    
                additionalContent: {
                    width: "23.75vw",
                    height: "18.85vw",
                    marginLeft: "1.04vw",
                    border: "0.15vw solid #01A9E0",
                    marginTop: "0vw",
                    marginBottom: "2.08vw",
                    borderRadius: "0.52vw"
                },
                additionalHeader: {
                    fontFamily: Font.Poppins,
                    fontSize: "0.93vw",
                    color: Color.DeepAsh,
                    marginTop: "1.40vw",
                    marginLeft: "1.87vw",
                    marginBottom: "1.04vw"
                },
                option: {
                    marginLeft: "1.04vw",
                    marginBottom: "0.52vw"
                },
                optionButton: {
                    width: "auto",
                    height: "1.82vw",
                    fontSize: "0.93vw",
                    padding: "0.36vw 1.04vw 0.41vw 1.04vw",
                    borderRadius: "0.52vw"
                },
                defaultText: {
                    fontSize: "0.93vw",
                    alignItems: "center",
                    marginLeft: "0.62vw"
                },
                answerText: {
                    fontSize: "0.93vw",
                    alignItems: "center"
                },
                rightWrapper: {
                    display: "flex",                   
                    flexDirection: 'column',
                    marginLeft: "2.81vw",
                    width: "21.61vw",
                    border: "0.15vw solid #DEDEDE",
                    borderRadius: "0.52vw",
                    order: 2,
                    marginTop: "0vw",
                    marginBottom: "0vw",
                    paddingBottom: "1.2vw"
                },
                domainHeader: {
                    fontFamily: Font.Poppins,
                    fontSize: "0.93vw",
                    color: Color.DeepAsh,
                    marginLeft: "1.35vw",
                    marginTop: "1.04vw",
                    marginBottom: "1.04vw" 
                },
                inputLabel: {
                    fontSize: "0.93vw",
                    marginLeft: "1.35vw"
                },
                textInput: {
                    width: '19.94vw',
                    height: '3.64vw',
                    marginLeft: '0.83vw'
                },
                submitButton: {
                    width: "10.93vw",
                    height: "1.82vw",
                    fontSize: "0.72vw",
                    padding: "0.36vw 1.04vw 0.41vw 1.04vw",
                    borderRadius: "0.36vw",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginLeft: "9.84vw",
                    marginTop: "1.04vw"
                },
                line: {
                    marginTop: "1.30vw",
                    marginBottom: "1.56vw",
                    width: "19.94vw",
                    height: "0.15vw",
                    border: "none",
                    marginLeft: "0.83vw",
                    backgroundColor: Color.MiddleAsh
                },
                domains: {
                    fontSize: "0.72vw",
                    borderRadius: "0.36vw",
                    padding: "0.52vw",
                    marginRight: "0.52vw",
                    marginTop: "0.52vw"                   
                },
                closeIcon: {
                    width: "0.93vw",
                    height: "0.93vw",
                    minWidth: "0.93vw",
                    minHeight: "0.93vw",
                    marginLeft: "0.52vw",
                    marginRight: "0.52vw",
                    boxSizing: "border-box" as "border-box"
                },
                domainContent: {
                    display: "flex",
                    width: "19.94vw",
                    marginLeft: "0.83vw",
                    marginRight: "0.83vw"
                },
                dulicateMessage: {
                    boxShadow: "3px 3px 10px #00000029",
                    display: "none",
                    position: 'absolute',
                    fontSize: "0.72vw",
                    padding: "0.4vw",                  
                    border: "1px solid " + Color.Gray,
                    borderRadius: "0.4vw",
                    jobListSnippet: {
                        display: "block",
                        position: "absolute",
                        top: "-15%",
                        left: "12vw",             
                        borderTop: "1px solid #D1D1D1",
                        borderLeft: "1px solid #D1D1D1",
                        boxShadow: "7px 7px 10px #00000029"   
                    },
                    javaScriptSnippet: {
                        display: "block",
                        position: "absolute",
                        top: "15%",
                        left: "31vw",             
                        borderTop: "1px solid #D1D1D1",
                        borderLeft: "1px solid #D1D1D1",
                        boxShadow: "7px 7px 10px #00000029"   
                    },
                    cssStyleSnippet: {
                        display: "block",
                        position: "absolute",
                        top: "20%",
                        left: "33vw",             
                        borderTop: "1px solid #D1D1D1",
                        borderLeft: "1px solid #D1D1D1",
                        boxShadow: "7px 7px 10px #00000029"       
                    }                      
                },
                loader : {
                    marginTop: "1.04vw",
                    marginLeft: "1vw",
                    width: "19.94vw",
                    height: "5.16vw"
                } 
            },
            blueLotus: {
                mainWrapper: {
                    width: "33.54vw",
                    height: "35.72vw"
                },
                headerText: {
                    fontSize: "1.04vw",
                    marginLeft: "1.40vw",
                    marginBottom: "1.04vw",
                    marginTop: "0vw"
                },
                inputLabel: {
                    fontSize: "0.93vw",
                    marginLeft: "1.35vw"
                },
                textInput: {
                    width: '32.44vw',
                    height: '3.64vw',
                    marginLeft: '0.83vw'
                },
                submitButton: {
                    width: "10.93vw",
                    height: "1.82vw",
                    fontSize: "0.72vw",
                    fontWeight: "bold" as "bold",
                    padding: "0.36vw 1.04vw 0.41vw 1.04vw",
                    borderRadius: "0.36vw",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginLeft: " 21.56vw",
                    marginTop: "1.04vw"
                },
                line: {
                    marginTop: "1.30vw",
                    marginBottom: "1.56vw",
                    width: "32.44vw",
                    height: "0.15vw",
                    border: "none",
                    marginLeft: "0.83vw"
                },
                domainContent: {
                    width: "32.44vw",
                    height: "auto",
                    marginLeft: "0.83vw",
                    marginRight: "0.83vw"
                },
                domains: {
                    display: "flex",
                    flexDirection: "row" as "row",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "auto",
                    height: "1.92vw",
                    fontSize: "0.72vw",
                    borderRadius: "0.36vw",
                    padding: "0.52vw",
                    marginRight: "0.52vw",
                    marginTop: "0.52vw"
                },
                closeIcon: {
                    width: "0.93vw",
                    height: "0.93vw",
                    marginLeft: "0.52vw",
                    marginRight: "0.52vw"
                },
                loader: {
                    marginTop: "1.04vw",
                    marginLeft: "1vw",
                    width: "32.5vw",
                    height: "3.64vw"
                }
            }
        },
        searchWrapper: {
            display: "flex",
            flexDirection: "row" as "row",
            height: "4.68vw",
            paddingRight: "1.56vw"
        },
        searchBar: {
            display: "flex",
            alignItems: 'center',
            position: 'relative',
            backgroundColor: Color.Cultured,
            marginTop: "0.52vw",
            marginBottom: "1.56vw",
            width: "25.21vw",
            borderRadius: "0.52vw",
            height: "2.6vw",
            input: {
                border: "none",
                backgroundColor: Color.Cultured,
                width: "21vw",
                paddingLeft: "1.04vw"
            },
            icon: {
                position: "absolute" as "absolute",
                fill: Color.SharpAsh,
                width: "1.14vw",
                height: "1.25vw",
                left: '23.06vw',
                cursor: "pointer"
            }
        }
    }
}